(function () {

    /**
     * Controls the opening and closing of a single hotspot
     * @param hotspotWrapper
     * @constructor
     */
    function Hotspot(hotspotWrapper) {

        var _this = this;

        var $hotspotWrapper = $(hotspotWrapper);

        var hotspotButtonSelector = '.js-hotspots--hotspot-button';

        var $hotspotButton = $($hotspotWrapper.find(hotspotButtonSelector));

        var $hotspotContent = $($hotspotWrapper.find('.js-hotspots--hotspot-content'));

        var popupSelector = '.js-hotspots--hotspot-popup';

        const body = $('body');

        this.init = function () {
            _this.initializeHotspotButton();
            _this.initializeOverlayCloseListener()
        };

        /**
         * Open popup on click
         */
        this.initializeHotspotButton = function () {
            $hotspotButton.click(function () {
                body.addClass('freeze');
                let spotOverlay = document.createElement('div');
                $(spotOverlay).addClass('hotspot-overlay js-hotspot-overlay');

                let spotContent = $hotspotContent[0];
                spotOverlay.appendChild(spotContent);

                let closeButton = $(spotContent).find('.js-hotspots--hotspot-popup-close');
                _this.initializeCloseButtonListener(closeButton);

                // Initialize Carousel if present
                const currentSlider = $(spotContent).find('.slick-slider');
                if (currentSlider) {
                    $(currentSlider).slick('refresh');
                }

                body.prepend(spotOverlay);
                setTimeout(function () {
                    $(spotContent).addClass('hotspots--hotspot-popup-open');
                }, 100);
            });
        }

        /**
         * Close popup on close button
         * @param {object} button
         */
        this.initializeCloseButtonListener = function (button) {
            $(button).click(function () {
                _this.closeOverlay();
            });
        }

        /**
         * Close popup, when the user clicks on the overlay around the popup
         */
        this.initializeOverlayCloseListener = function () {
            $(document).on('click touchstart', function (event) {
                if (_this.isNotCurrentHotspotClicked(event)) {
                    _this.closeOverlay();
                }
            });
        }

        /**
         * Returns true if except it was inside the popup or on the popup button (when opening)
         * @param event
         * @returns {boolean}
         */
        this.isNotCurrentHotspotClicked = function (event) {
            return ($(event.target).parents(hotspotButtonSelector).length === 0 && $(event.target).parents(popupSelector).length === 0);
        }


        /**
         * remove overlay and unfreeze body
         */
        this.closeOverlay = function () {
            body.removeClass('freeze');
            $('.js-hotspots--hotspot-content').removeClass('hotspots--hotspot-popup-open');
            $hotspotWrapper[0].appendChild($hotspotContent[0]);
            $('.js-hotspot-overlay').remove();
        }

        _this.init();
    }

    window.Juzo = window.Juzo || {};

    window.Juzo.Hotspot = Hotspot;
})();
